module.exports = __webpack_public_path__ + "img/icon-search.eda4676d.svg";